
export const getAccountStatus = ({ stripeLoader, loader, reduxUserDetails, userDetails, subscription, isPremiumUser, isFreePlan }: any) => {
  const isNoPlanAccount =
    !stripeLoader &&
    !loader &&
    reduxUserDetails?.email &&
    userDetails?.temp === true &&
    (!subscription?.subscription_id || !isPremiumUser);

  const isExpireAccount =
    !stripeLoader &&
    !loader &&
    !isFreePlan &&
    reduxUserDetails?.email &&
    userDetails?.temp !== true &&
    (!subscription?.subscription_id || !isPremiumUser);

  return { isNoPlanAccount, isExpireAccount, isNoPlanOrExpire: isNoPlanAccount || isExpireAccount };
};

export const getFeedbackOptions = ({ isOfferApplied, isFreePlan, isNoPlanOrExpire, isMember, selectedTimeLine }: any) => {
  if (isOfferApplied || isFreePlan || isNoPlanOrExpire || isMember) {
    return [
      'Hiring someone to do it for me instead',
      'Missing Features',
      'Other'
    ];
  } else {
    return [
      // ...(selectedTimeLine === 'Annually' ? ['Prefer Monthly Billing'] : []),
      'Too expensive',
      ...(selectedTimeLine !== 'Annually'
        ? ['Not using the tool as much for now']
        : []),
      'Facing bugs',
      'Hiring someone to do it for me instead',
      'Missing Features',
      'Other'
    ];
  }
};
